/* ============================================================
   Clay Paw Print Kit — custom side cart (drawer) + auto upsells
   Opens on the 'cpk:added' event fired by cpk-product.js.
   ============================================================ */
(function () {
  'use strict';
  if (window.__cpkCartInit) return;
  window.__cpkCartInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function url(p) { return ROOT.replace(/\/$/, '') + p; }
  function drawer() { return document.querySelector('[data-cpk-cart-drawer]'); }

  function currency() {
    var d = drawer();
    return d ? (d.getAttribute('data-currency') || 'USD') : 'USD';
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(navigator.language || 'en-GB', { style: 'currency', currency: currency() }).format((cents || 0) / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function upsellIds() {
    var d = drawer();
    return d ? (d.getAttribute('data-upsell-ids') || '').split(',').filter(Boolean).map(Number) : [];
  }

  function openCart() {
    var d = drawer(); if (!d) return;
    d.classList.add('cpk-cart-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    var d = drawer(); if (!d) return;
    d.classList.remove('cpk-cart-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  function getCart() { return fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeQty(key, qty) {
    return fetch(url('/cart/change.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { return r.json(); });
  }

  function esc(str) { var e = document.createElement('div'); e.textContent = str == null ? '' : str; return e.innerHTML; }

  function render(cart) {
    var d = drawer(); if (!d) return;
    var ids = upsellIds();
    var itemsEl = d.querySelector('[data-cpk-cart-items]');
    var subtotalEl = d.querySelector('[data-cpk-cart-subtotal]');
    var countEl = d.querySelector('[data-cpk-cart-count]');
    var emptyEl = d.querySelector('[data-cpk-cart-empty]');
    var footEl = d.querySelector('[data-cpk-cart-foot]');

    if (itemsEl) {
      var html = '';
      cart.items.forEach(function (it) {
        if (ids.indexOf(it.variant_id) !== -1) return; // shown in upsell section instead
        var img = it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cpk-ci-variant">' + esc(it.variant_title) + '</div>' : '';
        html += '<div class="cpk-ci" data-key="' + esc(it.key) + '">'
          + '<div class="cpk-ci-img">' + img + '</div>'
          + '<div class="cpk-ci-info"><div class="cpk-ci-title">' + esc(it.product_title) + '</div>' + variant
          + '<div class="cpk-ci-qty"><button type="button" data-cpk-qty-dec aria-label="Decrease quantity">−</button>'
          + '<span>' + it.quantity + '</span>'
          + '<button type="button" data-cpk-qty-inc aria-label="Increase quantity">+</button>'
          + '<button type="button" class="cpk-ci-remove" data-cpk-remove aria-label="Remove">Remove</button></div></div>'
          + '<div class="cpk-ci-price">' + money(it.final_line_price) + '</div>'
          + '</div>';
      });
      itemsEl.innerHTML = html;
    }
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    if (countEl) countEl.textContent = cart.item_count;
    var mainCount = cart.items.filter(function (it) { return ids.indexOf(it.variant_id) === -1; }).length;
    if (emptyEl) emptyEl.style.display = mainCount > 0 ? 'none' : 'block';
    if (footEl) footEl.style.display = cart.item_count > 0 ? '' : 'none';

    d.querySelectorAll('[data-cpk-upsell]').forEach(function (row) {
      var vid = Number(row.getAttribute('data-variant-id'));
      var inCart = cart.items.some(function (it) { return it.variant_id === vid; });
      var cb = row.querySelector('[data-cpk-upsell-check]');
      if (cb) cb.checked = inCart;
      row.classList.toggle('cpk-upsell-active', inCart);
    });
  }

  function refresh() { return getCart().then(render); }

  var autoAdded = false;
  function autoAddUpsells() {
    var d = drawer(); if (!d) return Promise.resolve();
    if (d.getAttribute('data-auto-select') !== 'true') return Promise.resolve();
    if (autoAdded) return Promise.resolve();
    autoAdded = true;
    var ids = upsellIds();
    if (!ids.length) return Promise.resolve();
    return getCart().then(function (cart) {
      var toAdd = ids
        .filter(function (id) { return !cart.items.some(function (it) { return it.variant_id === id; }); })
        .map(function (id) { return { id: id, quantity: 1 }; });
      if (!toAdd.length) return cart;
      return addItems(toAdd);
    });
  }

  function bind() {
    var d = drawer(); if (!d) return;

    d.querySelectorAll('[data-cpk-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    var overlay = d.querySelector('[data-cpk-cart-overlay]');
    if (overlay) overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    d.addEventListener('click', function (e) {
      var row = e.target.closest ? e.target.closest('.cpk-ci') : null;
      if (!row) return;
      var key = row.getAttribute('data-key');
      var cur = parseInt(row.querySelector('.cpk-ci-qty span').textContent, 10) || 1;
      if (e.target.closest('[data-cpk-qty-inc]')) changeQty(key, cur + 1).then(render);
      else if (e.target.closest('[data-cpk-qty-dec]')) changeQty(key, Math.max(0, cur - 1)).then(render);
      else if (e.target.closest('[data-cpk-remove]')) changeQty(key, 0).then(render);
    });

    d.querySelectorAll('[data-cpk-upsell-check]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var row = cb.closest('[data-cpk-upsell]');
        var vid = Number(row.getAttribute('data-variant-id'));
        if (cb.checked) {
          addItems([{ id: vid, quantity: 1 }]).then(render);
        } else {
          getCart().then(function (cart) {
            var line = cart.items.filter(function (it) { return it.variant_id === vid; })[0];
            if (line) changeQty(line.key, 0).then(render); else render(cart);
          });
        }
      });
    });

    d.querySelectorAll('[data-cpk-checkout]').forEach(function (b) {
      b.addEventListener('click', function () { window.location.href = url('/checkout'); });
    });

    document.querySelectorAll('[data-cpk-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); refresh().then(openCart); });
    });
  }

  function onAdded() { autoAddUpsells().then(refresh).then(openCart); }

  function init() {
    if (!drawer()) return;
    bind();
    refresh();
    document.addEventListener('cpk:added', onAdded);
    window.cpkOpenCart = function () { refresh().then(openCart); };
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
